import Select from 'react-select'
import Label from './Label';
import Input from './Input';
import { Children } from 'react';

const IsRequiredField = ({ isRequired, value, isSubmitted }) => {
    return (
        <>
            {isRequired && !value && isSubmitted && <span className="block text-xs text-red-500"> This field is required </span>}
        </>
    )
}

const IsRequiredFieldSelect = ({ isRequired, value, isSubmitted }) => {
    return (
        <>
            {isRequired && value?.length == 0 && isSubmitted && <span className="block text-xs text-red-500"> This field is required </span>}
        </>
    )
}

const Switch = () => {
    return (
        <div classNam="flex justify-center">
            <div classNam="form-check form-switch">
                <input
                    classNam="form-check-input appearance-none w-9 -ml-10 rounded-full float-left h-5 align-top bg-white bg-no-repeat bg-contain bg-gray-300 focus:outline-none cursor-pointer shadow-sm"
                    type="checkbox"
                    role="switch"
                    id="flexSwitchCheckDefault"
                />
                <label classNam="form-check-label inline-block text-gray-800" for="flexSwitchCheckDefault">Give only the year(Yes/No)</label>
            </div>
        </div>
    )
}

// For simple input
const SimpleTextInput = ({
    value,
    placeholder,
    fieldName,
    onChange,
    isSubmitted,
    onClick,
    showHelp = false,
    help,
    textHelp,
    isRequired = false,
    readOnly

}) => {

    return (
        <div>
            <Label isRequired={isRequired}>{fieldName}
                {showHelp && <button className="ml-1 text-red-400 text-sm" onClick={onClick}>
                    (?)
                </button>}
            </Label>
            {help &&
                <p className="text-xs text-gray-600">
                    {textHelp}
                </p>
            }
            <Input
                type="text"
                required
                placeholder={placeholder}
                value={value}
                onChange={onChange}
                disabled={readOnly}
                readOnly={readOnly}
            />
            <IsRequiredField
                value={value}
                isRequired={isRequired}
                isSubmitted={isSubmitted}
            />
        </div>
    )
}

// for select input
const SelectInput = ({
    fieldName,
    placeholder,
    value,
    myRef,
    options,
    onChange,
    isSubmitted,
    isRequired = false,
    getOptionLabel,
    getOptionValue,
    defaultValue,
    readOnly

}) => {

    return (
        <div className="space-y-2">
            <Label isRequired={isRequired}>{fieldName}</Label>
            <Select
                ref={myRef}
                placeholder={placeholder}
                options={options} 
                defaultValue={defaultValue&&{ value: defaultValue, label: defaultValue }}
                onChange={onChange}
                isDisabled={readOnly}
                getOptionLabel={getOptionLabel}
                getOptionValue={getOptionValue}
            />
            <IsRequiredField
                value={value}
                isRequired={isRequired}
                isSubmitted={isSubmitted}
            />
        </div>
    )

}

const RadioLink = ({
    fieldName,
    onChange,
    value,
    isRequired=false,
    readOnly
}) => {
    return(
        <div>
            <Label isRequired={isRequired}>{fieldName}</Label>
            <div className="w-6 space-y-4">
                <label className="flex flex-row space-x-4"> 
                    <Input
                        type="radio"
                        value={1}
                        id="checkYes"
                        disabled={readOnly}
                        readOnly={readOnly}
                        checked={value==1?true:false}
                        onChange={onChange}
                    />
                    <span className="mt-1.5">
                        Yes
                    </span>
                </label>
                <label className="flex flex-row space-x-4"> 
                    <Input
                        type="radio"
                        value={0}
                        id="checkNo"
                        disabled={readOnly}
                        readOnly={readOnly}
                        checked={value==0?true:false}
                        onChange={onChange}
                    />
                    <span className="mt-1.5">
                        No
                    </span>
                </label>
            </div>
        </div>
    )
}

// For date
const InputDate = ({
    fieldName,
    value,
    onChange,
    isSubmitted,
    isRequired = false,
    readOnly

}) => {

    return (
        <div>
            <Label isRequired={isRequired}>
                {fieldName} (yyyy)
            </Label>
            <Input
                type="text"
                value={value}
                maxLength={10}
                disabled={readOnly}
                readOnly={readOnly}
                onChange={onChange}
            />
            <IsRequiredField
                value={value}
                isRequired={isRequired}
                isSubmitted={isSubmitted}
            />
        </div>
    )
}

// For date
const TimeInput = ({
    fieldName,
    value,
    onChange,
    isSubmitted,
    showHelp = false,
    help,
    textHelp,
    onClick,
    isRequired = false,
    readOnly

}) => {

    return (
        <div>
            <Label isRequired={isRequired}>{fieldName} (min)
                {showHelp && <button className="ml-1 text-red-400 text-sm" onClick={onClick}>
                    (?)
                </button>}
            </Label>
            {help &&
                <p className="text-xs text-gray-600">
                    {textHelp}
                </p>
            }
            <Input
                type="text"
                value={value}
                onChange={onChange}
                disabled={readOnly}
                readOnly={readOnly}
            />
            <IsRequiredField
                value={value}
                isRequired={isRequired}
                isSubmitted={isSubmitted}
            />
        </div>
    )
}

// For multiple input
const MultipleInput = ({
    fieldName,
    placeholder,
    value,
    myRef,
    options,
    onChange,
    isSubmitted,
    isRequired = false,
    readOnly

}) => {

    return (
        <div>
            <Label isRequired={isRequired}>{fieldName}</Label>
            <Select
                onChange={onChange}
                ref={myRef}
                isDisabled={readOnly}
                /*getOptionLabel={option =>`${option.countries}`}
                getOptionValue={option =>`${option.countries}`}*/
                isMulti
                placeholder={placeholder}
                options={options}
                className="basic-multi-select"
                classNamePrefix="select"
            />
            <IsRequiredFieldSelect
                value={value}
                isRequired={isRequired}
                isSubmitted={isSubmitted}
            />
        </div>
    )

}

// For link
const LinkInput = ({
    fieldName,
    value,
    onChange,
    isSubmitted,
    isRequired = false,
    showHelp = false,
    help,
    textHelp,
    onClick,
    readOnly
}) => {

    return (
        <div>
            <Label isRequired={isRequired}>{fieldName}
                {showHelp && <button className="ml-1 text-red-400 text-sm" onClick={onClick}>
                    (?)
                </button>}
            </Label>
            {help &&
                <p className="text-xs text-gray-600">
                    {textHelp}
                </p>
            }
            {/* <div className="flex flex-row justify-between items-center"> */}
                {/* <div className="w-5/6"> */}
                    <Input
                        type="url"
                        value={value}
                        onChange={onChange}
                        disabled={readOnly}
                        readOnly={readOnly}
                    />
                    <IsRequiredField
                        value={value}
                        isRequired={isRequired}
                        isSubmitted={isSubmitted}
                    />
                {/* </div> */}
                {/* <div className="w-1/6"> */}
                    {/* <button onClick={addNewInput} className="ml-1 whitespace-nowrap px-6 py-2.5 mt-1.5 font-medium text-white bg-pblue">Add new link</button> */}
                {/* </div> */}
            {/* </div> */}
        </div>
    )

}

const TextareaInput = ({
    fieldName,
    value,
    refMessage,
    onChange,
    isSubmitted,
    showHelp = false,
    help,
    textHelp,
    onClick,
    isRequired = false,
    readOnly

}) => {

    return (
        <div className="flex flex-col space-y-3">
            <Label isRequired={isRequired}>{fieldName}
                {showHelp && <button className="ml-1 text-red-400 text-sm" onClick={onClick}>
                    (?)
                </button>}
            </Label>
            {help &&
                <p className="text-xs text-gray-600">
                    {textHelp}
                </p>
            }
            <textarea
                type="text"
                ref={refMessage}
                onChange={onChange}
                defaultValue={value}
                maxLength="255"
                disabled={readOnly}
                readOnly={readOnly}
                className="h-40 text-base leading-none text-gray-900 p-3 mt-4 bg-white border border-gray-200 focus:ring-0 focus:shadow-none focus:outline-none focus:border-none"
            >
            </textarea>
            <IsRequiredField
                value={value}
                isRequired={isRequired}
                isSubmitted={isSubmitted}
            />
        </div>
    )
}

const MultipleLinkInput = ({
    fieldName,
    value,
    isSubmitted,
    isRequired = false,
    showHelp = false,
    help,
    textHelp,
    onClick,
    onKeyUp,
    readOnly,
    showAlert=false,
    children
}) => { 
    return (
        <div className="flex flex-col space-y-3">
            <Label isRequired={isRequired}>{fieldName}
                {showHelp && <button className="ml-1 text-red-400 text-sm" onClick={onClick}>
                    (?)
                </button>}
                {showAlert&&<p className=" inline ml-2 text-sm text-red-600">
                   ( Press enter to add new link )
                </p>}
            </Label>
            {help &&
                <p className="text-xs text-gray-600">
                    {textHelp}
                </p>
            } 
            <div className="w-full">
                <ul id="tags" className="border-none">
                  {children}
                </ul>
                <Input
                    type="text"
                    onKeyUp={onKeyUp}
                    disabled={readOnly}
                    readOnly={readOnly}
                    placeholder="Press enter to add new link"
                />
                 <IsRequiredField
                    value={value}
                    isRequired={isRequired}
                    isSubmitted={isSubmitted}
                />
            </div>
        </div>
    );
};

export {
    SimpleTextInput,
    SelectInput,
    InputDate,
    LinkInput,
    TimeInput,
    TextareaInput,
    RadioLink,
    MultipleInput,
    MultipleLinkInput
}
